import React from 'react';
import Dropdown from '../../../V2/dropdown';
import DatePicker from '../../../V2/datepicker';
import MobileDatepicker from '../../../V2/datepicker/mobile-fullscreen';
import { PinIcon } from '../../../../assets/icons/Pin.icon';
import { CalendarIcon } from '../../../../assets/icons/Calendar.incon';
import { ChevronRightIcon } from '../../../../assets/icons/ChevronRight.icon';
import { formatPrice } from '../../../../utils';
import { PlaneIcon } from '../../../../assets/icons/Plane.icon';
import { ClockIcon } from '../../../../assets/icons/Clock.icon';
import styles from './stylesV2.module.css';

export const ModalOperatorConfirmationV2View = ({
  // Travel form
  destinations,
  selectedDestinationName,
  destinationDropdownOpen,
  onToggleDestinationDropdown,
  onSelectDestination,
  departureBr,
  returnBr,
  tripDays,
  onOpenDatepicker,
  // Datepicker
  isMobileDatepickerOpen,
  datepickMode,
  range,
  onRangeChange,
  onDatepickerConfirm,
  onDatepickerBack,
  onDatepickerClose,
  // Plan summary
  plan,
  providerImgPath,
  providerName,
  elderPrice,
  hasElderRange,
  // Desktop datepicker
  isDesktopPickerOpen,
  desktopPickerMode,
  onDesktopPickerChange,
  onDesktopPickerComplete,
  onDesktopPickerClose,
  // Confirmation
  isChecked,
  isFormComplete,
  isConfirming,
  onCheckChange,
  onConfirm,
}) => (
  <div className={styles.overlay}>
    <div className={styles.modal}>

      <div className={styles.header}>
        <div className={styles.headerTitle}>Quase lá! Revise seu pedido</div>
        <p className={styles.headerSubtitle}>
          Por favor, confira atentamente os <b>dados da viagem</b> (destino, datas) e o{' '}
          <b>Plano de Seguro Viagem que foi escolhido.</b>
        </p>
      </div>

      <div className={styles.content}>

        {/* Section: Travel Data */}
        <div className={styles.section}>
          <div className={styles.sectionHeading}>
            <PlaneIcon />
            <span>Verifique sua viagem</span>
          </div>

          <div className={styles.timeline}>
            <div className={styles.timelineConnector} />

            {/* Step 1: Destination */}
            <div className={styles.timelineStep}>
              <div className={styles.timelineStepContent}>
                <div className={styles.stepLabel}>Qual é o destino?</div>
                <div className={styles.inputDropdownWrapper}>
                  <div
                    className={styles.figmaInput}
                    role="button"
                    tabIndex={0}
                    onClick={onToggleDestinationDropdown}
                    onKeyDown={(e) => e.key === 'Enter' && onToggleDestinationDropdown()}
                  >
                    <span className={styles.figmaInputIcon}><PinIcon size={20} /></span>
                    <div className={styles.figmaInputTexts}>
                      <span className={styles.figmaInputLabel}>Destino</span>
                      {selectedDestinationName && (
                        <span className={styles.figmaInputValue}>{selectedDestinationName}</span>
                      )}
                    </div>
                    <ChevronRightIcon size={24} color="#9e9e9e" rotate={destinationDropdownOpen ? 270 : 90} />
                  </div>
                  <Dropdown isOpen={destinationDropdownOpen} onClose={() => onSelectDestination(null)}>
                    {destinations && destinations.length > 0 && (
                      <ul className={styles.destinationList}>
                        {destinations.map((d) => (
                          <li
                            key={d.id || d.slug}
                            className={styles.destinationItem}
                            onClick={() => onSelectDestination(d.slug)}
                          >
                            {d.name}
                            {(d.slug === 'brasil' || d.slug === 'receptivo') && (
                              <span className={styles.destinationDescription}>
                                {d.slug === 'brasil'
                                  ? 'Para viagens dentro do Brasil'
                                  : 'Para quem vem visitar o Brasil'}
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </Dropdown>
                </div>
              </div>
              <div className={styles.timelineBullet}>1</div>
            </div>

            {/* Step 2: Dates */}
            <div className={styles.timelineStep}>
              <div className={styles.timelineStepContent}>
                <div className={styles.stepLabel}>Quando você viaja?</div>
                <div className={styles.datesRow}>
                  <div
                    className={styles.figmaInput}
                    role="button"
                    tabIndex={0}
                    onClick={() => onOpenDatepicker('start')}
                    onKeyDown={(e) => e.key === 'Enter' && onOpenDatepicker('start')}
                  >
                    <span className={styles.figmaInputIcon}><CalendarIcon size={20} /></span>
                    <div className={styles.figmaInputTexts}>
                      <span className={styles.figmaInputLabel}>Embarque no Brasil</span>
                      {departureBr && <span className={styles.figmaInputValue}>{departureBr}</span>}
                    </div>
                  </div>
                  <div
                    className={styles.figmaInput}
                    role="button"
                    tabIndex={0}
                    onClick={() => onOpenDatepicker('end')}
                    onKeyDown={(e) => e.key === 'Enter' && onOpenDatepicker('end')}
                  >
                    <span className={styles.figmaInputIcon}><CalendarIcon size={20} /></span>
                    <div className={styles.figmaInputTexts}>
                      <span className={styles.figmaInputLabel}>Desembarque no Brasil</span>
                      {returnBr && <span className={styles.figmaInputValue}>{returnBr}</span>}
                    </div>
                  </div>
                </div>
                {isDesktopPickerOpen && (
                  <div onClick={onDesktopPickerClose} style={{ position: 'fixed', inset: 0, zIndex: 0 }} />
                )}
                {isDesktopPickerOpen && (
                  <div className={styles.desktopPickerCard}>
                    <DatePicker
                      variant="inline"
                      selectionMode={desktopPickerMode}
                      value={range}
                      onChange={onDesktopPickerChange}
                      onComplete={onDesktopPickerComplete}
                      minDate={new Date()}
                      allowSameDay
                      numberOfMonths={2}
                    />
                  </div>
                )}
                {tripDays && (
                  <div className={styles.durationBadge}>
                    <span>Duração da viagem:</span>
                    <span className={styles.durationValue}>
                      <ClockIcon />
                      {tripDays} dias
                    </span>
                  </div>
                )}
              </div>
              <div className={styles.timelineBulletInactive}>2</div>
            </div>
          </div>
        </div>

        {/* Section: Summary Card */}
        {plan && (
          <div className={styles.summaryCard}>
            <div className={styles.purchaseItem}>
              {providerImgPath && (
                <img src={providerImgPath} alt={providerName} className={styles.providerImg} />
              )}
              <div className={styles.planName}>{plan.name}</div>
            </div>
            <div className={styles.separator} />
            <div className={styles.detailsGrid}>
              <div className={styles.detailCell}>
                <span className={styles.detailLabel}>Faixa etária:</span>
                <span className={styles.detailValue}>
                  {plan.child && plan.elder
                    ? `${plan.child.min_age} a ${plan.elder.max_age} anos`
                    : '—'}
                </span>
              </div>
              {hasElderRange && elderPrice && (
                <div className={styles.detailCell}>
                  <span className={styles.detailLabel}>Valor acima de {plan.elder.min_age} anos:</span>
                  <span className={styles.detailValue}>R${formatPrice(elderPrice)}</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Checkbox */}
        <div className={styles.checkboxSection}>
          <div className={styles.checkboxRow}>
            <input
              type="checkbox"
              id="operator-confirm-v2"
              checked={isChecked}
              onChange={onCheckChange}
              className={styles.checkbox}
            />
            <label htmlFor="operator-confirm-v2" className={styles.checkboxText}>
              Ao prosseguir, declaro que <b>revisei e confirmei</b> todos os dados acima (datas,
              destino e plano). Entendo que é minha responsabilidade garantir que as informações
              estão corretas e, em caso de erro, a empresa não se responsabiliza por prejuízos
              decorrentes.
            </label>
          </div>
        </div>

        <button
          className={styles.confirmButton}
          disabled={!isFormComplete || !isChecked || isConfirming}
          onClick={onConfirm}
        >
          Confirmar ir para o pagamento
        </button>

      </div>

    </div>

    <MobileDatepicker
      open={isMobileDatepickerOpen}
      selectionMode={datepickMode}
      value={range}
      onChange={onRangeChange}
      onConfirm={onDatepickerConfirm}
      onBack={onDatepickerBack}
      onClose={onDatepickerClose}
      minDate={new Date()}
      allowSameDay
      labels={{ title: 'Selecione as datas' }}
    />
  </div>
);

export default ModalOperatorConfirmationV2View;



// WEBPACK FOOTER //
// ./src/components/purchase/modal_operator_confirmation/v2/ModalOperatorConfirmationV2View.jsx